import React, { useEffect, useState } from "react";
import { api, formatErr } from "@/lib/api";
import { PageHeader } from "@/components/Shared";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";

export default function Settings() {
  const [s, setS] = useState(null);
  const load = () => api.get("/settings").then((r) => setS(r.data));
  useEffect(() => { load(); }, []);
  if (!s) return <div className="text-slate-500">Caricamento…</div>;

  const save = async () => {
    try {
      await api.put("/settings", {
        otp_required: s.otp_required, org_header: s.org_header,
        token_expiry_days: Number(s.token_expiry_days) || 0,
      });
      toast.success("Impostazioni salvate");
    } catch (e) { toast.error(formatErr(e.response?.data?.detail)); }
  };

  return (
    <div>
      <PageHeader title="Impostazioni" subtitle="Configurazione generale del gestionale." />
      <Card className="p-6 border-slate-200 max-w-2xl space-y-6">
        <div className="flex items-center justify-between">
          <div>
            <Label className="text-base">Verifica OTP per link personale</Label>
            <p className="text-sm text-slate-500">Richiede un codice via e-mail prima di mostrare il registro personale.</p>
          </div>
          <Switch data-testid="otp-switch" checked={s.otp_required} onCheckedChange={(v) => setS({ ...s, otp_required: v })} />
        </div>
        <div>
          <Label>Intestazione documenti (PDF)</Label>
          <Input value={s.org_header || ""} onChange={(e) => setS({ ...s, org_header: e.target.value })} className="mt-1" />
        </div>
        <div>
          <Label>Scadenza link personale (giorni, 0 = nessuna)</Label>
          <Input type="number" value={s.token_expiry_days || 0} onChange={(e) => setS({ ...s, token_expiry_days: e.target.value })} className="mt-1 max-w-[160px]" />
        </div>
        <Button data-testid="save-settings-btn" onClick={save} className="bg-[#0B192C] hover:bg-[#07111E]">Salva</Button>
      </Card>
    </div>
  );
}
